import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";
import { ISizeRange, FetchSizeRangesCompletedAction } from "actions/collections";

export interface IState {
    result: ISizeRange[];
    loading: boolean;
    error: string;
}

const initialState: IState = {
    result: undefined,
    loading: false,
    error: undefined,
};

export const collectionSizing = handleActions<IState, any>(
    {
        [COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.FETCH.LOADING]: (state: IState, _action): IState => {
            return {
                ...initialState,
                loading: true,
            };
        },
        [COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.FETCH.COMPLETED]: (
            state: IState,
            action: FetchSizeRangesCompletedAction
        ): IState => {
            return {
                ...state,
                error: action.payload.error,
                result: action.payload.items,
                loading: false,
            };
        },
        [COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.RESET]: (): IState => {
            return initialState;
        },
    } as any,
    initialState
);
